import { render, staticRenderFns } from "./importCustomer.vue?vue&type=template&id=d55716a8&scoped=true"
import script from "./importCustomer.vue?vue&type=script&lang=js"
export * from "./importCustomer.vue?vue&type=script&lang=js"
import style0 from "./importCustomer.vue?vue&type=style&index=0&id=d55716a8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55716a8",
  null
  
)

export default component.exports